<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="novedadTiempo?.fecha" 
            [DateEnd]="novedadTiempo?.fecha"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="novedadesTiempoHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [enableCut]=false
            [CurrentPeriod]="novedadTiempo?.id">
</iboxtools>

<app-novedades-tiempos-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                         [novedadesTiempos]="novedadesTiempos" 
                                                         [permisoEdicion]="permisoEdicion"
                                                         (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-novedades-tiempos-list>

<app-novedades-tiempos-detalle #ChildNovedadTiempoDetalle [novedadTiempo]="novedadTiempo" *ngIf="verDetalle" 
                          [enabledForm]="habilitarFormDetalle" 
                          [MensajeError]="MensajeError" 
                          [desdeAnterior]="desdeAnterior" 
                          [ingreso]="ingreso"
                          [anteriorRetroactividad]="anteriorRetroactividad" 
                          [grupoLiq]="gruposLiquidaciones" 
                          [novedadesInvalida]="novedadesInvalida">
</app-novedades-tiempos-detalle>

